export const Location = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 20 18" {...props}>
    <path
      fill="currentColor"
      d="M13.3033 13.4698L8 18.7731L2.6967 13.4698C-0.232233 10.5408 -0.232233 5.79214 2.6967 2.8632C5.62563 -0.0657294 10.3743 -0.0657294 13.3033 2.8632C16.2323 5.79214 16.2323 10.5408 13.3033 13.4698ZM8 11.4998C9.84092 11.4998 11.3333 10.0074 11.3333 8.1665C11.3333 6.32555 9.84092 4.83317 8 4.83317C6.15905 4.83317 4.66667 6.32555 4.66667 8.1665C4.66667 10.0074 6.15905 11.4998 8 11.4998ZM8 9.83317C7.0795 9.83317 6.33333 9.087 6.33333 8.1665C6.33333 7.24603 7.0795 6.49984 8 6.49984C8.9205 6.49984 9.66667 7.24603 9.66667 8.1665C9.66667 9.087 8.9205 9.83317 8 9.83317Z"
    />
  </svg>
);
